"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderChildren = void 0;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const renderChildren = (children, props) => {
    if (typeof children === "function") {
        return children(props);
    }
    else {
        return children;
    }
};
exports.renderChildren = renderChildren;
//# sourceMappingURL=renderChildren.js.map